import Accordions from '@/components/sections/Accordions'
import Banner from '@/components/sections/Banner'
import HeroPoster from '@/components/sections/HeroPoster'
import HeroTitle from '@/components/sections/HeroTitle'
import ImageCards from '@/components/sections/ImageCards'
import ImageFullSlider from '@/components/sections/ImageFullSlider'
import ImageText from '@/components/sections/ImageText'
import ImageTextSlider from '@/components/sections/ImageTextSlider'
import MediaImage from '@/components/sections/MediaImage'
import MediaVideo from '@/components/sections/MediaVideo'
import Newsletter from '@/components/sections/Newsletter'
import ParagraphBlock from '@/components/sections/ParagraphBlock'
import PostArchive from '@/components/sections/PostArchive'
import PushCards from '@/components/sections/PushCards'
import SolidCards from '@/components/sections/SolidCards'
import Spacer from '@/components/sections/Spacer'
import TextBlock from '@/components/sections/TextBlock'

export const sectionsMap: any = {
  accordions: Accordions,
  banner: Banner,
  hero_poster: HeroPoster,
  hero_title: HeroTitle,
  image_cards: ImageCards,
  image_full_slider: ImageFullSlider,
  image_text: ImageText,
  image_text_slider: ImageTextSlider,
  media_image: MediaImage,
  media_video: MediaVideo,
  newsletter: Newsletter,
  paragraph_block: ParagraphBlock,
  archive_post_types: PostArchive,
  push_cards: PushCards,
  solid_cards: SolidCards,
  spacer: Spacer,
  text_block: TextBlock
}
